import { useEffect } from 'react'
import ga4 from 'react-ga4'
import { useLocation } from 'react-router-dom'

export function useAnalytics() {
    const TRACKING_ID = 'G-Z8GRNX83G1' // Move to env varaiable
    const isProduction = process.env.NODE_ENV === 'production'
    const location = useLocation()

    const init = () =>
        ga4.initialize(TRACKING_ID, {
            testMode: !isProduction,
        })
    useEffect(() => {
        init()
    }, [])

    useEffect(() => {
        const path = location.pathname + location.search
        logPageView(path)
    }, [location])
}

export const logEvent = (eventName: string, value: any) => {
    ga4.event(eventName, value)
}

export const logPageView = (path: string) =>
    ga4.send({
        hitType: 'pageview',
        page: path,
    })

export default useAnalytics
